import Vue from 'vue'
import "./assets/styles/style.scss"
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueScrollTo from 'vue-scrollto';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import "./plugins/vee-validate";
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});
Vue.use(VueAxios, axios);
Vue.use(VueToast);
Vue.config.productionTip = false;

new Vue({
    created() {
        AOS.init()
    },
    render: h => h(App),
}).$mount('#app');
